import { emptyValidator, formValidator } from "../../validators";

const supplierPaymentHoldValidationStatus = {
    sphEvInvType: {
        validators: [emptyValidator()],
        name: "EV/INV",
    },
    sphRefType: {
        validators: [emptyValidator()],
        name: "Type",
    },
    sphReferences: {
        validators: [emptyValidator()],
        name: "Suppliers/Jobs",
    },
    sphReason: {
        validators: [emptyValidator()],
        name: "Reason",
    },
};

export const supplierPaymentHoldValidation = (supplierPayment) => {
    return formValidator(supplierPayment, supplierPaymentHoldValidationStatus);
};